import { App } from 'vue'
import Avatar from './LpAvatar.vue'

Avatar.install = (Vue: App) => {
  Vue.component(Avatar.name, Avatar)
}

export default Avatar
